export const GENERIC_STOCK_PROJECT_IDS = [
    '5PTOLWxGSlbxiVNHXnPS',
    'e53q7UtHlGJGebrQmuYI',
    '0GHXhokYZbbKxOeWY9oa',
    'v2W1U0sciUFEasQl6hri',
]

export const isGenericStockProject = projectId =>
    GENERIC_STOCK_PROJECT_IDS.includes(projectId)
